export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center bg-lavender-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-28 pb-14 w-full">

        {/* Magazine-style header */}
        <div className="border-t-4 border-b-4 border-gray-900 py-3 mb-10">
          <p className="text-xs tracking-[0.3em] text-gray-600 text-center uppercase" style={{ fontFamily: "'Inter', sans-serif" }}>
            Law Office of Hong-min Jun — Attorney at Law — Indianapolis, Indiana
          </p>
        </div>

        {/* Two-column layout */}
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-14">

          {/* Left column — Text */}
          <div className="flex-1 min-w-0 flex flex-col justify-center">

            {/* Main headline */}
            <h1 className="text-5xl md:text-6xl lg:text-[72px] font-light text-gray-900 mb-6 leading-[1.0] tracking-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              Attorney for<br />
              <span className="font-normal italic">Foreign-Borns:</span><br />
              Personal Injury<br />
              <span className="font-normal italic">&amp; Immigration.</span>
            </h1>

            {/* Motto */}
            <p className="text-xs tracking-[0.22em] uppercase text-gray-500 mb-8" style={{ fontFamily: "'Inter', sans-serif" }}>
              Attorney for Foreign-Born Individuals and Small Business Owners
            </p>

            {/* Subheadline */}
            <div className="border-l-2 border-gray-900 pl-7 mb-10">
              <p className="text-base md:text-lg text-gray-700 leading-relaxed font-light" style={{ fontFamily: "'Crimson Pro', serif" }}>
                Dedicated legal representation for foreign-born individuals and small business owners in Indiana. We understand your unique challenges and fight for your rights with expertise and compassion.
              </p>
            </div>

            {/* CTA buttons */}
            <div className="flex flex-col sm:flex-row gap-3 items-start mb-12">
              <button
                onClick={scrollToContact}
                className="bg-gray-900 text-white px-9 py-4 text-xs tracking-wider uppercase hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                Free Consultation
              </button>
              <a
                href="tel:+13177012768"
                className="border-2 border-gray-900 text-gray-900 px-9 py-4 text-xs tracking-wider uppercase hover:bg-gray-900 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                (317) 701-2768
              </a>
            </div>

            {/* Bottom accent */}
            <div className="pt-7 border-t border-gray-200">
              <div className="flex flex-wrap gap-5 text-[11px] tracking-wider uppercase text-gray-500">
                <span>No Win, No Fee</span>
                <span>•</span>
                <span>Multilingual Support</span>
                <span>•</span>
                <span>Confidential Consultation</span>
              </div>
            </div>
          </div>

          {/* Right column — Photo */}
          <div className="flex-shrink-0 w-full lg:w-[600px] flex items-start justify-center">
            <div className="w-full h-[864px] overflow-hidden relative">
              <img
                src="https://public.readdy.ai/ai/img_res/3247b759-44b0-4101-96f9-55dfb2bbecde.png"
                alt="Hong-min Jun — Founding Attorney"
                className="w-full absolute"
                style={{ top: '-80px', left: 0, transform: 'scale(1.1)', transformOrigin: 'top center' }}
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
